<div class="http-error">
  <p><b><ng-content></ng-content></b></p>
  <i class="small">({{ error | httpErrorMsg }})</i>
</div>